/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const send_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11.1 15.632 5.21 6.955a1.664 1.664 0 0 0 2.966-.69l3.6-19.174a1.663 1.663 0 0 0-2.516-1.72L1.877 12.557a1.664 1.664 0 0 0 .882 3.075H11.1Zm0 0H8.6v5.171a1.663 1.663 0 0 0 2.6 1.374l3.178-2.166-3.278-4.379Zm-.001 0 11.08-14.59"
    />
  </svg>
)
export default send_medium
